"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseViewModel = void 0;
class BaseViewModel {
}
exports.BaseViewModel = BaseViewModel;
//# sourceMappingURL=BaseViewModel.js.map